const amountHeaderDrawer = ($document, $timeout) => {
  return {
    restrict: "E",
    template: require("./template.html"),
    link: (scope, element) => {
      scope.clickDocument = () => {
        scope.closeHeaderDrawer();
        // Because this callback is manually added (i.e. via `$document.$on`
        // rather than `ngClick`), `scope#$apply` also needs to be called
        // manually to redraw the caret icon after `scope.isOpen` is updated in
        // `#closeHeaderDrawer`.
        scope.$apply();
      };

      scope.openHeaderDrawer = () => {
        // Capture header anchor to return focus when dropdown is closed (WCAG
        // requirement)
        scope.activeElement = $document[0].activeElement;
        scope.$broadcast("amountTrapFocus:reset", scope.activeElement);

        scope.isOpen = true;
        $document.on("click", scope.clickDocument);
      };

      scope.closeHeaderDrawer = () => {
        scope.isOpen = false;
        scope.activeElement.focus();
        $document.unbind("click", scope.clickDocument);
      };

      scope.toggleHeaderDrawer = event => {
        scope.isOpen ? scope.closeHeaderDrawer() : scope.openHeaderDrawer();
        // When the click handler that calls this function is fired, there is a
        // race condition where the click handler added to the document in
        // `#openHeaderDrawer` may already be set before the click event that
        // added it is done propogating down through the page.
        // So `#stopPropagation` is used to prevent the click from going all the
        // way down and closing the drawer immediately after it's opened.
        event.stopPropagation();
      };

      scope.drawer = element.find(".header__drawer");
      scope.isOpen = false;
      scope.$on("amountTrapFocus:close", () => scope.closeHeaderDrawer());
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountHeaderDrawer", ["$document", "$timeout", amountHeaderDrawer]);
